import axiosClient from "utils/api";
const URI = "/admin/holiday";

export const getHoliday = async (payload) => {
  const URL = `${URI}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Holiday:", error);
    throw error;
  }
};
export const addHoliday = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred during add Holiday:", error);
    throw error;
  }
};

export const updateHoliday = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred during add Holiday:", error);
    throw error;
  }
};

export const deleteHoliday = async (payload) => {
  const URL = `${URI}/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });

    return response.data;
  } catch (error) {
    console.error("Error occurred during add Holiday:", error);
    throw error;
  }
};
